import { useState, useEffect, useMemo } from 'react';
import { ExperienceNames } from '../experience-tracker/ExperienceNames';
import { EMBEDDED_PARENT_PRODUCTS } from '../page-common';
export const useFooter = ({
  experienceTracker,
  hasFooter,
  hasFooterLogo,
  parentProduct,
  standaloneConfluenceUrl
}) => {
  const [footerUrl, setFooterUrl] = useState(standaloneConfluenceUrl);
  useEffect(() => {
    setFooterUrl(standaloneConfluenceUrl);
  }, [standaloneConfluenceUrl]);
  useEffect(() => {
    const unsubscribe = experienceTracker.subscribe(event => {
      const {
        name,
        action
      } = event;
      if (name === ExperienceNames.PAGE_NOT_FOUND && action === 'taskStart') {
        setFooterUrl(standaloneConfluenceUrl ? `${new URL(standaloneConfluenceUrl).origin}/wiki/home` : standaloneConfluenceUrl);
      }
    });
    return () => unsubscribe();
  }, [experienceTracker, standaloneConfluenceUrl]);

  /**
   * Currently footer is hidden for the JSM Portal view which passes
   * hasFooterLogo prop as false and shown for all other views
   *
   * JSM portal view will provide "JSM-Portal" as the parent product eventually
   * However, team is still testing this product type for Atlassian and anonymous users so the "JSM-Portal" parentProduct is being feature-flagged
   * We need to support these two parent product keys to keep backward compatibile for the time being.
   *
   * Clean-up task in backlog: https://hello.atlassian.net/browse/CBT-1278 to remove "JSM" from the logic
   */
  const showFooter = useMemo(() => !!hasFooter && !((parentProduct === EMBEDDED_PARENT_PRODUCTS.JSM_PORTAL || parentProduct === EMBEDDED_PARENT_PRODUCTS.JSM) && !hasFooterLogo), [parentProduct, hasFooterLogo, hasFooter]);
  return {
    showFooter,
    footerUrl
  };
};